import React from "react";
import { Button, Modal, ModalProps } from "semantic-ui-react";
import { instanceOf } from "prop-types";
import { withCookies, Cookies } from "react-cookie";

class MessageStartup extends React.Component<ModalProps, any> {
    static propTypes = {
        cookies: instanceOf(Cookies).isRequired
    };
    state = { visible: true};
    messageId;
    dismiss: string[] = [];
    constructor(props: ModalProps) {
        super(props);
        const { cookies, topic, subtopic } = this.props;
        const cookieString = cookies.get("mv-dismiss");
        this.messageId = topic +(subtopic? "_"+subtopic:"")+ "_start";
        this.dismiss = cookieString? cookieString.split(";"): [];
        this.state = {
            visible: !this.dismiss.includes(this.messageId)
        };
        this.handleDismiss = this.handleDismiss.bind(this);
    }
    handleDismiss = (): void => {
        const { cookies } = this.props;
        this.setState({ visible: false });
        this.dismiss.push(this.messageId);
        cookies.set("mv-dismiss", this.dismiss.join(";"), { path: "/", sameSite: "lax" });
    };

    render(): JSX.Element | null {
        if (this.state.visible) {
            let className = "geo-component";
            if (this.props.className) {
                className += " " + this.props.className;
            }
            // quick and dirty!
            const content = <p dangerouslySetInnerHTML={{__html: this.props.content as string}}/>;
            return (
                <Modal
                    className={className}
                    dimmer={"blurring"}
                    open={this.state.visible}
                    onClose={this.handleDismiss}
                >
                    <Modal.Header>{this.props.header}</Modal.Header>
                    <Modal.Content>
                        <Modal.Description>
                            {content}
                        </Modal.Description>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button onClick={this.handleDismiss} primary>OK</Button>
                    </Modal.Actions>
                </Modal>
            );
        }

        return null;
    }
}
export default withCookies(MessageStartup);
